// TODO: Replace the following with your app's Firebase project configuration
// For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
export const firebaseTestConfig = {
  apiKey: "AIzaSyBdt44mkpPCqRsLSx40dfYLXbzg_MgydTM",
  authDomain: "glassolutionsrackpickup.firebaseapp.com",
  databaseURL: "https://glassolutionsrackpickup-test.europe-west1.firebasedatabase.app/",
  projectId: "glassolutionsrackpickup",
  storageBucket: "glassolutionsrackpickup.appspot.com",
  messagingSenderId: "989833300909",
  appId: "1:989833300909:web:7a1fa761faef56604eef24",
  measurementId: "G-6W917W30TG",
};